import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '@env/environment'
import { Observable, catchError, of } from 'rxjs'
import { IIdentity } from '../data-types/identity.interface'

@Injectable({ providedIn: 'root' })
export class GetIdentityQuery {
  constructor(private httpClient: HttpClient) {}

  call(): Observable<IIdentity> {
    const url = `${environment.api.app}/identities/current`
    return this.httpClient.get<IIdentity>(url).pipe(catchError(() => of(<IIdentity>{})))
  }
}
